module.exports = __webpack_public_path__ + "static/img/2.2c93e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncajzx/2.png
// module id = h+X9
// module chunks = 1